/** Query-String für die Postfach-Endpunkte — leere Werte fallen weg. */
export function postfachParams(params: Record<string, string | null | undefined>): string {
  const p = new URLSearchParams()
  for (const [k, v] of Object.entries(params)) if (v) p.set(k, v)
  return p.toString()
}
